import type { Href } from 'expo-router';

import { useGoBack } from '@/hooks/useGoBack';

type NavigationParams = Record<string, string | undefined>;

function withParams(
  route: Href | undefined,
  params: NavigationParams | undefined
): Href | undefined {
  if (!route || !params || typeof route !== 'string') {
    return route;
  }

  return { pathname: route as never, params: params as never };
}

/**
 * Back for a screen that declares where it belongs. It follows history when the entry before is
 * the app's and otherwise replaces the screen with `parentRoute`, or the Directory when none is
 * given. See `useGoBack`, which this names for the screens that already call it.
 */
export function useBackNavigation(parentRoute?: Href, params?: NavigationParams) {
  const navigateBack = useGoBack(withParams(parentRoute, params));

  return { navigateBack };
}
